tinymce.addI18n("pt_BR", {
    "#": "#",
    "Accessibility": "Acessibilidade",
    "Accordion": "Acorde\xe3o",
    "Accordion body...": "Corpo do acorde\xe3o...",
    "Accordion summary...": "Resumo do acorde\xe3o...",
    "Action": "A\xe7\xe3o",
    "Activity": "Atividade",
    "Address": "Endere\xe7o",
    "Advanced": "Avan\xe7ado",
    "Align": "Alinhamento",
    "Align center": "Centralizar",
    "Align left": "Alinhar \xe0 esquerda",
    "Align right": "Alinhar \xe0 direita",
    "Alignment": "Alinhamento",
    "Alignment {0}": "Alinhamento {0}",
    "All": "Tudo",
    "Alternative description": "Descri\xe7\xe3o alternativa",
    "Alternative source": "Endere\xe7o alternativo",
    "Alternative source URL": "Endere\xe7o URL alternativo",
    "Anchor": "\xc2ncora",
    "Anchor...": "\xc2ncora...",
    "Anchors": "\xc2ncoras",
    "Animals and Nature": "Animais e Natureza",
    "Arrows": "Setas",
    "B": "B",
    "Background color": "Cor do fundo",
    "Background color {0}": "Cor de fundo {0}",
    "Black": "Preto",
    "Block": "Par\xe1grafo",
    "Block {0}": "Bloco {0}",
    "Blockquote": "Bloco de cita\xe7\xe3o",
    "Blocks": "Par\xe1grafo",
    "Blue": "Azul",
    "Blue component": "Componente azul",
    "Body": "Corpo",
    "Bold": "Negrito",
    "Border": "Borda",
    "Border color": "Cor da borda",
    "Border style": "Estilo da borda",
    "Border width": "Espessura da borda",
    "Bottom": "Inferior",
    "Browse files": "Procurar arquivos",
    "Browse for an image": "Procurar uma imagem",
    "Browse links": "Procurar links",
    "Bullet list": "Lista com marcadores",
    "Cancel": "Cancelar",
    "Caption": "Legenda",
    "Cell": "C\xe9lula",
    "Cell padding": "Espa\xe7amento interno da c\xe9lula",
    "Cell properties": "Propriedades da c\xe9lula",
    "Cell spacing": "Espa\xe7amento da c\xe9lula",
    "Cell styles": "Estilos da c\xe9lula",
    "Cell type": "Tipo de c\xe9lula",
    "Center": "Centro",
    "Characters": "Caracteres",
    "Characters (no spaces)": "Caracteres (sem espa\xe7os)",
    "Circle": "C\xedrculo",
    "Class": "Classe",
    "Clear formatting": "Limpar formata\xe7\xe3o",
    "Close": "Fechar",
    "Code": "Mono espa\xe7ada",
    "Code sample...": "C\xf3digo...",
    "Code view": "Ver c\xf3digo",
    "Color Picker": "Seletor de cores",
    "Color swatch": "Amostra de cor",
    "Cols": "Colunas",
    "Column": "Coluna",
    "Column clipboard actions": "A\xe7\xf5es da \xe1rea de transfer\xeancia de colunas",
    "Column group": "Grupo de colunas",
    "Column header": "Cabe\xe7alho da coluna",
    "Constrain proportions": "Restringir propor\xe7\xf5es",
    "Copy": "Copiar",
    "Copy column": "Copiar coluna",
    "Copy row": "Copiar linha",
    "Could not find the specified string.": "N\xe3o foi poss\xedvel encontrar o termo especificado.",
    "Could not load emojis": "N\xe3o foi poss\xedvel carregar os emojis",
    "Count": "Contar",
    "Currency": "Moeda",
    "Current window": "Janela atual",
    "Custom color": "Cor personalizada",
    "Custom...": "Personalizado...",
    "Cut": "Recortar",
    "Cut column": "Recortar coluna",
    "Cut row": "Recortar linha",
    "Dark Blue": "Azul escuro",
    "Dark Gray": "Cinza escuro",
    "Dark Green": "Verde escuro",
    "Dark Orange": "Laranja escuro",
    "Dark Purple": "Roxo escuro",
    "Dark Red": "Vermelho escuro",
    "Dark Turquoise": "Turquesa escuro",
    "Dark Yellow": "Amarelo escuro",
    "Dashed": "Tracejada",
    "Date/time": "Data/hora",
    "Decrease indent": "Diminuir recuo",
    "Default": "Padr\xe3o",
    "Delete accordion": "Excluir acorde\xe3o",
    "Delete column": "Excluir coluna",
    "Delete row": "Excluir linha",
    "Delete table": "Excluir tabela",
    "Dimensions": "Dimens\xf5es",
    "Disc": "Disco",
    "Div": "Se\xe7\xe3o (div)",
    "Document": "Documento",
    "Dotted": "Pontilhada",
    "Double": "Dupla",
    "Drop an image here": "Arraste uma imagem para c\xe1",
    "Dropped file type is not supported": "O tipo do arquivo arrastado n\xe3o \xe9 compat\xedvel",
    "Edit": "Editar",
    "Embed": "Incorporar",
    "Emojis": "Emojis",
    "Emojis...": "Emojis...",
    "Error": "Erro",
    "Error: Form submit field collision.": "Erro: colis\xe3o de bot\xe3o de envio do formul\xe1rio.",
    "Error: No form element found.": "Erro: elemento de formul\xe1rio n\xe3o encontrado.",
    "Extended Latin": "Latino estendido",
    "Failed to initialize plugin: {0}": "Falha ao iniciar plugin: {0}",
    "Failed to load plugin url: {0}": "Falha ao carregar URL do plugin: {0}",
    "Failed to load plugin: {0} from url {1}": "Falha ao carregar plugin: {0} da URL {1}",
    "Failed to upload image: {0}": "Falha ao carregar imagem: {0}",
    "File": "Arquivo",
    "Find": "Localizar",
    "Find (if searchreplace plugin activated)": "Localizar (se o plugin de localizar e substituir estiver ativado)",
    "Find and Replace": "Localizar e substituir",
    "Find and replace...": "Localizar e substituir...",
    "Find in selection": "Localizar na sele\xe7\xe3o",
    "Find whole words only": "Encontrar somente palavras inteiras",
    "Flags": "Bandeiras",
    "Focus to contextual toolbar": "Focalizar barra de ferramentas contextual",
    "Focus to element path": "Focalizar caminho do elemento",
    "Focus to menubar": "Focalizar barra de menus",
    "Focus to toolbar": "Focalizar barra de ferramentas",
    "Font": "Fonte",
    "Font size {0}": "Tamanho da fonte {0}",
    "Font sizes": "Tamanho da fonte",
    "Font {0}": "Fonte",
    "Fonts": "Fonte",
    "Food and Drink": "Comida e Bebida",
    "Footer": "Rodap\xe9",
    "Format": "Formatar",
    "Format {0}": "Formato {0}",
    "Formats": "Formata\xe7\xe3o",
    "Fullscreen": "Tela cheia",
    "G": "G",
    "General": "Geral",
    "Gray": "Cinza",
    "Green": "Verde",
    "Green component": "Componente verde",
    "Groove": "Chanfrada",
    "Handy Shortcuts": "Atalhos \xfateis",
    "Header": "Cabe\xe7alho",
    "Header cell": "C\xe9lula de cabe\xe7alho",
    "Heading 1": "T\xedtulo 1",
    "Heading 2": "T\xedtulo 2",
    "Heading 3": "T\xedtulo 3",
    "Heading 4": "T\xedtulo 4",
    "Heading 5": "T\xedtulo 5",
    "Heading 6": "T\xedtulo 6",
    "Headings": "T\xedtulos",
    "Height": "Altura",
    "Help": "Ajuda",
    "Hex color code": "C\xf3digo hexadecimal de cor",
    "Hidden": "Oculta",
    "Horizontal align": "Alinhamento horizontal",
    "Horizontal line": "Linha horizontal",
    "Horizontal space": "Espa\xe7o horizontal",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "O ID deve come\xe7ar com uma letra, seguida apenas por letras, n\xfameros, tra\xe7os, v\xedrgulas ou sublinhas.",
    "Image is decorative": "A imagem \xe9 decorativa",
    "Image list": "Lista de imagens",
    "Image title": "T\xedtulo da imagem",
    "Image...": "Imagem...",
    "ImageProxy HTTP error: Could not find Image Proxy": "Erro de HTTP ImageProxy: n\xe3o foi poss\xedvel encontrar o proxy de imagem",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "Erro de HTTP ImageProxy: URL de proxy de imagem incorreto",
    "ImageProxy HTTP error: Rejected request": "Erro HTTP ImageProxy: solicita\xe7\xe3o rejeitada",
    "ImageProxy HTTP error: Unknown ImageProxy error": "Erro de HTTP ImageProxy: erro ImageProxy desconhecido",
    "Increase indent": "Aumentar recuo",
    "Inline": "Fonte",
    "Insert": "Inserir",
    "Insert Template": "Inserir modelo",
    "Insert accordion": "Inserir acorde\xe3o",
    "Insert column after": "Inserir coluna depois",
    "Insert column before": "Inserir coluna antes",
    "Insert date/time": "Inserir data/hora",
    "Insert image": "Inserir imagem",
    "Insert link (if link plugin activated)": "Inserir link (se o plugin de link estiver ativado)",
    "Insert row after": "Inserir linha depois",
    "Insert row before": "Inserir linha antes",
    "Insert table": "Inserir tabela",
    "Insert template...": "Inserir modelo...",
    "Insert video": "Inserir v\xeddeo",
    "Insert/Edit code sample": "Inserir/editar c\xf3digo",
    "Insert/edit image": "Inserir/editar imagem",
    "Insert/edit link": "Inserir/editar link",
    "Insert/edit media": "Inserir/editar m\xeddia",
    "Insert/edit video": "Inserir/editar v\xeddeo",
    "Inset": "Baixo relevo",
    "Invalid hex color code: {0}": "C\xf3digo hexadecimal de cor inv\xe1lido: {0}",
    "Invalid input": "Entrada inv\xe1lida",
    "Italic": "It\xe1lico",
    "Justify": "Justificar",
    "Keyboard Navigation": "Navega\xe7\xe3o pelo teclado",
    "Language": "Idioma",
    "Learn more...": "Saber mais...",
    "Left": "\xc0 esquerda",
    "Left to right": "Esquerda para direita",
    "Light Blue": "Azul claro",
    "Light Gray": "Cinza claro",
    "Light Green": "Verde claro",
    "Light Purple": "Roxo claro",
    "Light Red": "Vermelho claro",
    "Light Yellow": "Amarelo claro",
    "Line height": "Altura da linha",
    "Link list": "Lista de links",
    "Link...": "Link...",
    "List Properties": "Listar propriedades",
    "List properties...": "Listar propriedades...",
    "Loading emojis...": "Carregando emojis...",
    "Loading...": "Carregando...",
    "Lower Alpha": "Letra Min\xfasc",
    "Lower Greek": "Grego Min\xfasc.",
    "Lower Roman": "Romano Min\xfasc.",
    "Match case": "Diferenciar mai\xfascula/min\xfascula",
    "Mathematical": "Matem\xe1tico",
    "Media poster (Image URL)": "Post de m\xeddia (URL da Imagem)",
    "Media...": "M\xeddia...",
    "Medium Blue": "Azul m\xe9dio",
    "Medium Gray": "Cinza m\xe9dio",
    "Medium Purple": "Roxo m\xe9dio",
    "Merge cells": "Agrupar c\xe9lulas",
    "Middle": "Meio",
    "Midnight Blue": "Azul meia-noite",
    "More...": "Mais...",
    "Name": "Nome",
    "Navy Blue": "Azul marinho",
    "New document": "Novo documento",
    "New window": "Nova janela",
    "Next": "Pr\xf3xima",
    "No": "N\xe3o",
    "No alignment": "Sem alinhamento",
    "No color": "Nenhuma cor",
    "Nonbreaking space": "Espa\xe7o inquebr\xe1vel",
    "None": "Nenhum(a)",
    "Numbered list": "Lista numerada",
    "OR": "OU",
    "Objects": "Objetos",
    "Ok": "OK",
    "Open help dialog": "Abrir di\xe1logo de ajuda",
    "Open link": "Abrir link",
    "Open link in...": "Abrir link em...",
    "Open popup menu for split buttons": "Abrir menu popup para bot\xf5es com divis\xe3o",
    "Orange": "Laranja",
    "Outset": "Alto relevo",
    "Page break": "Quebra de p\xe1gina",
    "Paragraph": "Simples",
    "Paste": "Colar",
    "Paste as text": "Colar como texto",
    "Paste column after": "Colar coluna depois",
    "Paste column before": "Colar coluna antes",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "O comando Colar est\xe1 no modo de texto simples. O conte\xfado ser\xe1 colado como texto simples, at\xe9 voc\xea desligar essa op\xe7\xe3o.",
    "Paste or type a link": "Cole ou digite um link",
    "Paste row after": "Colar linha depois",
    "Paste row before": "Colar linha antes",
    "Paste your embed code below:": "Insira o c\xf3digo de incorpora\xe7\xe3o abaixo:",
    "People": "Pessoas",
    "Plugins": "Plugins",
    "Plugins installed ({0}):": "Plugins instalados ({0}):",
    "Powered by {0}": "Distribu\xeddo por {0}",
    "Pre": "Pr\xe9-formatado (pre)",
    "Preferences": "Prefer\xeancias",
    "Preformatted": "Pr\xe9-formatado",
    "Premium plugins:": "Plugins premium:",
    "Press the Up and Down arrow keys to resize the editor.": "Use as teclas de seta acima e abaixo para redimensionar o editor.",
    "Press the arrow keys to resize the editor.": "Pressione as teclas de seta para redimensionar o editor.",
    "Press {0} for help": "Pressione {0} para ajuda",
    "Preview": "Pr\xe9-visualizar",
    "Previous": "Anterior",
    "Print": "Imprimir",
    "Print...": "Imprimir...",
    "Purple": "Roxo",
    "Quotations": "Cita\xe7\xf5es",
    "R": "R",
    "Range 0 to 255": "Faixa entre 0 e 255",
    "Red": "Vermelho",
    "Red component": "Componente vermelho",
    "Redo": "Redo",
    "Remove": "Remover",
    "Remove color": "Remover cor",
    "Remove link": "Remover link",
    "Replace": "Substituir",
    "Replace all": "Substituir tudo",
    "Replace with": "Substituir por",
    "Resize": "Redimensionar",
    "Restore last draft": "Restaurar \xfaltimo rascunho",
    "Reveal or hide additional toolbar items": "Exibir ou ocultar itens adicionais da barra de ferramentas",
    "Rich Text Area": "\xc1rea de texto rico",
    "Rich Text Area. Press ALT-0 for help.": "\xc1rea de texto rico. Pressione Alt+0 para ajuda.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "\xc1rea de texto rico. Pressione Alt+F9 para exibir o menu, Alt+F10 para exibir a barra de ferramentas ou Alt+0 para exibir a ajuda.",
    "Ridge": "Ressaltada",
    "Right": "\xc0 direita",
    "Right to left": "Direita para esquerda",
    "Row": "Linha",
    "Row clipboard actions": "A\xe7\xf5es da \xe1rea de transfer\xeancia de linhas",
    "Row group": "Grupo de linhas",
    "Row header": "Cabe\xe7alho da linha",
    "Row properties": "Propriedades da linha",
    "Row type": "Tipo de linha",
    "Rows": "Linhas",
    "Save": "Salvar",
    "Save (if save plugin activated)": "Salvar (se o plugin de salvar estiver ativado)",
    "Scope": "Escopo",
    "Search": "Pesquisar",
    "Select all": "Selecionar tudo",
    "Select...": "Selecionar...",
    "Selection": "Sele\xe7\xe3o",
    "Shortcut": "Atalho",
    "Show blocks": "Mostrar blocos",
    "Show caption": "Exibir legenda",
    "Show invisible characters": "Exibir caracteres invis\xedveis",
    "Size": "Tamanho",
    "Solid": "S\xf3lida",
    "Source": "Endere\xe7o",
    "Source code": "C\xf3digo-fonte",
    "Special Character": "Caractere especial",
    "Special character...": "Caractere especial...",
    "Split cell": "Dividir c\xe9lula",
    "Square": "Quadrado",
    "Start list at number": "Iniciar a lista no n\xfamero",
    "Strikethrough": "Tachado",
    "Style": "Estilo",
    "Subscript": "Subscrito",
    "Superscript": "Sobrescrito",
    "Switch to or from fullscreen mode": "Abrir ou fechar modo de tela cheia",
    "Symbols": "S\xedmbolos",
    "System Font": "Fonte do sistema",
    "Table": "Tabela",
    "Table caption": "Legenda da tabela",
    "Table properties": "Propriedades da tabela",
    "Table styles": "Estilos de tabela",
    "Template": "Modelo",
    "Templates": "Modelos",
    "Text": "Texto",
    "Text color": "Cor do texto",
    "Text color {0}": "Cor do texto {0}",
    "Text to display": "Texto a ser exibido",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "A URL que voc\xea informou parece ser um endere\xe7o de e-mail. Deseja adicionar o prefixo obrigat\xf3rio mailto:?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "A URL que voc\xea informou parece ser um link externo. Deseja incluir o prefixo http://?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "A URL informada parece ser um link externo. Deseja adicionar o prefixo obrigat\xf3rio https://?",
    "Title": "T\xedtulo",
    "To open the popup, press Shift+Enter": "Para abrir o di\xe1logo, pressione Shit+Enter",
    "Toggle accordion": "Alternar acorde\xe3o",
    "Tools": "Ferramentas",
    "Top": "Superior",
    "Travel and Places": "Viagem e Lugares",
    "Turquoise": "Turquesa",
    "Underline": "Sublinhado",
    "Undo": "Desfazer",
    "Upload": "Carregar",
    "Uploading image": "Carregando imagem",
    "Upper Alpha": "Letra Mai\xfasc.",
    "Upper Roman": "Romano Mai\xfasc.",
    "Url": "URL",
    "User Defined": "Definido pelo Usu\xe1rio",
    "Valid": "V\xe1lido",
    "Version": "Vers\xe3o",
    "Vertical align": "Alinhamento vertical",
    "Vertical space": "Espa\xe7o vertical",
    "View": "Visualizar",
    "Visual aids": "Ajuda visual",
    "Warn": "Alerta",
    "White": "Branco",
    "Width": "Largura",
    "Word count": "Contador de palavras",
    "Words": "Palavras",
    "Words: {0}": "Palavras: {0}",
    "Yellow": "Amarelo",
    "Yes": "Sim",
    "You are using {0}": "Voc\xea est\xe1 usando {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Voc\xea tem altera\xe7\xf5es n\xe3o salvas. Voc\xea tem certeza de que deseja sair?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "\nSeu navegador n\xe3o suporta acesso direto \xe0 \xe1rea de transfer\xeancia. Em vez disso, use os atalhos de teclado Ctrl+X/C/V.",
    "alignment": "alinhamento",
    "austral sign": "s\xedmbolo do austral",
    "cedi sign": "s\xedmbolo do cedi",
    "colon sign": "s\xedmbolo do colon",
    "cruzeiro sign": "s\xedmbolo do cruzeiro",
    "currency sign": "s\xedmbolo de moeda",
    "dollar sign": "s\xedmbolo do d\xf3lar",
    "dong sign": "s\xedmbolo do dong",
    "drachma sign": "s\xedmbolo do drachma",
    "euro-currency sign": "s\xedmbolo do euro",
    "example": "exemplo",
    "formatting": "formata\xe7\xe3o",
    "french franc sign": "s\xedmbolo do franco franc\xeas",
    "german penny symbol": "s\xedmbolo de centavo alem\xe3o",
    "guarani sign": "s\xedmbolo do guarani",
    "history": "hist\xf3rico",
    "hryvnia sign": "s\xedmbolo do hryvnia",
    "indentation": "indenta\xe7\xe3o",
    "indian rupee sign": "s\xedmbolo de r\xfapia indiana",
    "kip sign": "s\xedmbolo do kip",
    "lira sign": "s\xedmbolo da lira",
    "livre tournois sign": "s\xedmbolo do livre tournois",
    "manat sign": "s\xedmbolo do manat",
    "mill sign": "s\xedmbolo do mill",
    "naira sign": "s\xedmbolo da naira",
    "new sheqel sign": "s\xedmbolo do novo sheqel",
    "nordic mark sign": "s\xedmbolo do marco n\xf3rdico",
    "peseta sign": "s\xedmbolo da peseta",
    "peso sign": "s\xedmbolo do peso",
    "ruble sign": "s\xedmbolo do rublo",
    "rupee sign": "s\xedmbolo da r\xfapia",
    "spesmilo sign": "s\xedmbolo do spesmilo",
    "styles": "estilos",
    "tenge sign": "s\xedmbolo do tenge",
    "tugrik sign": "s\xedmbolo do tugrik",
    "turkish lira sign": "s\xedmbolo de lira turca",
    "won sign": "s\xedmbolo do won",
    "yen character": "caractere do yen",
    "yen/yuan character variant one": "varia\xe7\xe3o do caractere de yen/yuan",
    "yuan character": "caractere do yuan",
    "yuan character, in hong kong and taiwan": "caractere do yuan, em Hong Kong e Taiwan",
    "{0} characters": "{0} caracteres",
    "{0} columns, {1} rows": "{0} colunas, {1} linhas",
    "{0} words": "{0} palavras"
});